module.exports = {
  theme: {
    colors: {
      primary: '#2a2aff',
      black: '#22292f',
      success: '#00c853',
    },
    fonts: {
      sans: [
        'Source Sans Pro',
        'Arial',
        'sans-serif'
      ]
    },
    typography: {
      body: {
        font: 'sans',
        leading: 'md',
        color: 'black',
        weight: 'normal',
        size: 'md'
      },
      title: {
        font: 'sans',
        leading: 'sm',
        weight: 'bold'
      },
      paragraph: {
        leading: 'lg',
        weight: 'light'
      },
      link: {
        color: 'primary'
      }
    }
  }
}
